import z from 'zod';
import { UserInformationSchema } from '../base';

export const IEventsIntegrationEventSchema = z.object({
    user: UserInformationSchema.nullish(),
    id: z.string(),
    correlationId: z.string(),
    eventId: z.string().nullish(),
    seriesId: z.string().nullish(),
});

export const EventsBaseIntegrationEventSchema = IEventsIntegrationEventSchema.extend({
    timestamp: z.string(),
});

export type IEventsIntegrationEvent = z.infer<typeof IEventsIntegrationEventSchema>;

export type BaseEventsIntegrationEvent = z.infer<typeof EventsBaseIntegrationEventSchema>;
